import { createPart } from "ag-grid-community";

export const warningCellPart = createPart({
	css: `
	  .max-limit {
		color: var(--ag-warning-cell-foreground-color);
		font-weight: var(--ag-warning-cell-font-weight);
		background-color: var(--ag-warning-cell-background-color);
	  }
	`,
	params: {
		warningCellForegroundColor: " #CC0000",
		warningCellFontWeight: 600,
		warningCellBackgroundColor: "transparent",
	},
});

export const infoCellPart = createPart({
	css: `
	  .info-limit {
		color: var(--ag-info-cell-foreground-color);
		background-color: var(--ag-info-cell-background-color);
		font-weight: var(--ag-info-cell-font-weight);
	  }
	`,
	params: {
		infoCellForegroundColor: " #000",
		infoCellBackgroundColor: " #b2e5ed",
		infoCellFontWeight: 600,
	},
});

export const monthReportCellPart = createPart({
	css: `
	  .month-report {
		background-color: var(--ag-info-cell-background-color);
	  }
	  
	  .month-report:hover {
		background-color: #DAE5EA;
	  }
	`,
	params: {
		infoCellBackgroundColor: " #E9F2F7",
	},
});

export const assetChipPart = createPart({
	css: `
    .custom-chip {
      display: inline-flex;
      align-items: center;
      padding: 4px 12px;
      border-radius: 16px;
      font-size: 0.8125rem;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      line-height: 1.5;
      cursor: default;
    }

    .ag-cell.eaf-11 .custom-chip {
      font-weight: 500;
      color: #192a4d;
      background-color: #dae8fc;
      border: 1px solid #a6c8f7;
    }

    .ag-cell.eaf-12 .custom-chip {
      font-weight: 500;
      color: #273d25;
      background-color: #d5e8d4;
      border: 1px solid #a3d3a1;
    }
  `,
	params: {},
});

export const labTableParts = createPart({
	css: `
	  .cell-below-min {
		background-color: #ffa500; /* ORANGE_WEB */
		font-weight: bold;
	  }

	  .cell-above-max {
		background-color: #f26b6b; /* LIGHT_CARMINE_PINK */
		font-weight: bold;
	  }

	  .ag-header-cell-label {
		display: flex;
		justify-content: center;
		align-items: center;
	  }
	`,
	params: {},
});

export const shiftChipPart = createPart({
	css: `
    .custom-chip {
      display: inline-flex;
      align-items: center;
      padding: 2px 12px;
      border-radius: 16px;
      font-size: 0.8125rem;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      line-height: 1.5;
      cursor: default;
    }

    .ag-cell.shift-chip-D .custom-chip {
      font-weight: 800;
      color:rgb(255, 255, 255);
      background-color: #DDD116;
      border: 1px solid rgb(224, 208, 101);
    }

    .ag-cell.shift-chip-N .custom-chip {
      font-weight: 800;
      color:rgb(255, 255, 255);
	  background-color:rgb(161, 66, 221);
      border: 1px solid rgb(183, 102, 233);
    }
  `,
	params: {},
});

export const crewChipPart = createPart({
	css: `
    .custom-chip {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 0.8125rem;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      line-height: 1.5;
      cursor: default;
      min-width: 24px;
      height: 24px;
    }

    .ag-cell.crew-chip-A .custom-chip {
      font-weight: 800;
      color:rgb(255, 255, 255);
      background-color: #B2E08A;
      border: 1px solid #B2E08A;
    }

    .ag-cell.crew-chip-B .custom-chip {
      font-weight: 800;
      color:rgb(236, 236, 236);
	  background-color: #E83011;
      border: 1px solid #E83011;
    }

    .ag-cell.crew-chip-C .custom-chip {
      font-weight: 800;
      color:rgb(255, 255, 255);
      background-color: #3878B4;
      border: 1px solid #3878B4;
    }

    .ag-cell.crew-chip-D .custom-chip {
      font-weight: 800;
      color:rgb(255, 255, 255);
      background-color: #F3A506;
      border: 1px solid #F3A506;
    }
  `,
	params: {},
});
